import React from "react";
import { CheckCircle2, ShieldCheck, HardDrive, FileBadge, ScanBarcode } from "lucide-react";

const BENEFITS = [
  "Single vendor for IT, electrical and furniture categories",
  "Transparent, institutional pricing model",
  "Multi-city simultaneous execution capability",
  "Certified data wiping with Certificate of Destruction",
  "Full GST compliance and official audit trails",
];

const SECURITY = [
  { icon: ScanBarcode, title: "Asset Identification", desc: "Serial-number tracking of every unit from inspection to pickup." },
  { icon: HardDrive, title: "Data Wiping Options", desc: "NIST 800-88 compliant erasure or physical drive destruction on request." },
  { icon: FileBadge, title: "Destruction Certificates", desc: "Official documentation for your internal compliance audits." },
];

export const CorpTrust = () => (
  <section id="why-kapatia" data-testid="corporate-trust-section" className="home-section home-section--corporate scroll-mt-24" style={{ background: "#F8FBF4" }}>
    <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
      <div>
        <p className="text-[12px] font-bold uppercase tracking-[0.16em]" style={{ color: "#E8501A" }}>Why Kapatia</p>
        <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl" style={{ color: "var(--green-950)" }}>
          Why Businesses Choose Kapatia
        </h2>
        <ul className="mt-8 space-y-4">
          {BENEFITS.map((b, i) => (
            <li key={i} data-testid={`benefit-item-${i}`} className="flex items-start gap-3">
              <CheckCircle2 size={20} className="mt-0.5 shrink-0" style={{ color: "var(--green-800)" }} />
              <span className="text-[15px] font-medium leading-relaxed" style={{ color: "#0F172A" }}>{b}</span>
            </li>
          ))}
        </ul>
      </div>

      <div data-testid="security-section" className="rounded-2xl p-7 text-white sm:p-9" style={{ background: "var(--green-950)" }}>
        <div className="flex items-center gap-3">
          <ShieldCheck size={24} style={{ color: "#F5B400" }} />
          <h2 className="font-heading text-xl font-bold sm:text-2xl">Data Security & Compliance</h2>
        </div>
        <p className="mt-3 text-[14px] leading-relaxed text-white/70">
          Every engagement includes asset identification and documented data-handling — so your IT and
          compliance teams sign off with confidence.
        </p>
        <div className="mt-7 space-y-5">
          {SECURITY.map((s) => (
            <div key={s.title} className="flex items-start gap-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg" style={{ background: "rgba(255,255,255,0.08)" }}>
                <s.icon size={19} style={{ color: "#F5B400" }} />
              </div>
              <div>
                <h3 className="font-heading text-[15px] font-bold">{s.title}</h3>
                <p className="mt-1 text-[13px] leading-relaxed text-white/65">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
